import { render } from "./CounterwiseQuota.vue?vue&type=template&id=acc92de4&scoped=true"
import script from "./CounterwiseQuota.vue?vue&type=script&lang=js"
export * from "./CounterwiseQuota.vue?vue&type=script&lang=js"

import "./CounterwiseQuota.vue?vue&type=style&index=0&id=acc92de4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acc92de4"]])

export default __exports__